import React from 'react';

export const WebLayout = ({ children }) => {
  return <div>{children}</div>;
};
